import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import { useAuthenticatedUserContext } from "../../features/Auth/UserProvider";

export const Logout: React.FC = () => {
  // FIXME: call server to log out which in turn removes cookies
  const { clearUser } = useAuthenticatedUserContext();
  useEffect(clearUser);
  return <Redirect to="/" />;
};
